import { translateObjectInverse } from '@huggg/bar-staff';
import { prop } from 'ramda';
import { urls } from '../config';
import withAxios from '../utils/with-axios';
var walletTopUpFieldMap = {
  id: 'id',
  status: 'status',
  userId: 'user_id',
  retailPrice: 'retail',
  createdAt: 'created_at',
  updatedAt: 'updated_at',
  purchasedAtDate: 'purchased_at_date',
  purchasedAtTime: 'purchased_at_time',
  quantity: 'quantity'
};

/**
 * Formats top up wallet respose
 * @param {Object} data
 */
function formatWalletTopUpResponseData(data) {
  return translateObjectInverse(walletTopUpFieldMap, data);
}

/**
 * Fetches all users wallets.
 *
 * @param {Object} [$axios=axios] Axios instance.
 * @returns {Promise} Unresolved Promise from the API.
 * @throws {Error} When user id is missing.
 */
function fetch($axios, userId) {
  if (!userId) {
    throw new Error('Prop `userId` is required in `wallets.fetch`');
  }
  return $axios.get(urls.apiV2("/user/".concat(userId, "/wallets"))).then(prop('data'));
}

/**
 * Fetch data for a single transaction at the supplied ID.
 * @param {Object} [$axios=axios] Axios instance.
 * @param {String} id Wallet ID to fetch data
 * @returns {Promise} Unresolved Promise from the API.
 */
function single($axios, id) {
  return $axios.get(urls.apiV2("/wallets/".concat(id))).then(prop('data'));
}

/**
 * Tops up a users wallet
 * @param {Object} [$axios=axios] Axios instance.
 * @param {Object} data The topup request data
 * @param {String} data.walletId Wallet ID to fetch data
 * @param {String} data.method The payment method: card, token or charge
 * @param {String} data.reference Token ID to use to pay from stripe or charge ID from the charge service
 * @param {Number} data.amount Amount in pounds
 * @param {String} data.userId User ID
 */
function topUp($axios, _ref) {
  var walletId = _ref.walletId,
    _ref$method = _ref.method,
    method = _ref$method === void 0 ? 'token' : _ref$method,
    reference = _ref.reference,
    amount = _ref.amount,
    _ref$userId = _ref.userId,
    userId = _ref$userId === void 0 ? null : _ref$userId;
  var penceConversion = 100;
  var request = {
    userId: userId,
    payment: {
      method: method,
      reference: reference
    },
    purchase: {
      type: 'walletTopUp',
      reference: walletId,
      amount: Math.round(amount * penceConversion)
    }
  };
  return $axios.post(urls.apiV2("/wallets/".concat(walletId, "/top-up")), request).then(prop('data')).then(formatWalletTopUpResponseData);
}

/**
 * Sends a remittance advice trigger to hubspot
 *
 * @param {Object} [$axios=axios] Axios instance.
 * @param {Object} data The remittance advice request data
 * @param {String} data.walletId Wallet ID
 * @param {Number} data.amount Amount in pounds
 */
function getRemittanceAdvice($axios, _ref2) {
  var walletId = _ref2.walletId,
    amount = _ref2.amount;
  var penceConversion = 100;
  var request = {
    amount: Math.round(amount * penceConversion)
  };
  return $axios.post(urls.apiV2("/wallets/".concat(walletId, "/remittance-advice")), request).then(prop('data'));
}
export default {
  fetch: withAxios(fetch),
  getRemittanceAdvice: withAxios(getRemittanceAdvice, {
    useBackoff: false
  }),
  single: withAxios(single),
  topUp: withAxios(topUp, {
    useBackoff: false
  })
};